var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticStyle: { "min-height": "50px" },
    },
    [
      _vm.visible
        ? _c("fm-generate-form", {
            ref: "generateForm",
            staticClass: "readonly",
            attrs: { data: _vm.options, edit: _vm.edit, value: _vm.formData },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }